/**
 * @generated SignedSource<<7e22b23fdf74856cd8dc1b0e2d239527>>
 * @relayHash 68505bc224ec19edfba49afd43c7d907
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99

import type { ConcreteRequest } from 'relay-runtime';
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type useAnalyticsByLineQuery$variables = {
  contentId: string;
};
export type useAnalyticsByLineQuery$data = {
  readonly contentAnalyticsViewers: {
    readonly count: number;
  } | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type useAnalyticsByLineQuery = {
  response: useAnalyticsByLineQuery$data;
  variables: useAnalyticsByLineQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "ContentAnalyticsViewers",
    "kind": "LinkedField",
    "name": "contentAnalyticsViewers",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "count"
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "permissionType"
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAnalyticsByLineQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAnalyticsByLineQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "68505bc224ec19edfba49afd43c7d907",
    "id": "7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99",
    "metadata": {},
    "name": "useAnalyticsByLineQuery",
    "operationKind": "query",
    "text": "query useAnalyticsByLineQuery($contentId:ID!){contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
  }
};
})();

(node as any).hash = "1059930ceaf11a1fca0cb8f2f9d20c27";

export default node;
